<template>
    <div
        class="well-info"
        :class="{ 'instrument-geri-compare-page': isGeriOrMiri && isComparePage }"
    >
        <compare-well-checkbox :well="well" />
        <div v-if="isGeriOrMiri && isComparePage" class="geri-well-info">
            <well-chamber-number />
            <div class="geri-well-id">
                <well-id :well="well" />
                <well-embryo-id-view class="px-1 text-light-2" :with-bar="true" :well="well" />
            </div>
        </div>
        <template v-else>
            <well-id :well="well" />
            <well-embryo-id-view class="px-1 text-light-2" :with-bar="isGeriOrMiri" :well="well" />
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { INSTRUMENT_TYPE, TREATMENT_PAGE_VIEWS } from '../../business/const'
import CompareWellCheckbox from './common/CompareWellCheckbox'
import WellChamberNumber from './WellChamberNumber'
import WellEmbryoIdView from './common/WellEmbryoIdView'
import WellId from './WellId'
export default {
    name: 'WellInfo',
    components: { WellId, WellEmbryoIdView, WellChamberNumber, CompareWellCheckbox },
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            currentView: state => state.navigation.currentView
        }),
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),

        isComparePage() {
            return this.currentView === TREATMENT_PAGE_VIEWS.COMPARE_WELLS
        },
        isGeriOrMiri() {
            return (
                this.getSelectedInstrument.type &&
                [INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(
                    this.getSelectedInstrument.type
                )
            )
        }
    }
}
</script>

<style lang="scss">
.well-info {
    width: 100%;
    height: 60px;
    overflow: hidden;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    font-size: 9pt;
    color: $light-3;
    background: transparent linear-gradient(180deg, #000000b3 0%, #00000000 100%) 0 0 no-repeat
        padding-box;

    &.instrument-geri-compare-page {
        align-items: flex-start;
        padding-top: 0.25rem;
    }

    .geri-well-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        .geri-well-id {
            display: flex;
        }
    }
}
</style>
